import React, { useEffect, useState } from "react";
import { Title, TitleSection, Wrapper } from "../Properties/Details/styles";
import requestAPI from "../../utils/requestAPI";
import reports from "../../apiConfigs/reports";
import { toast } from "react-toastify";
import {
  renderFullDetails,
  renderstatus,
} from "../../designComponents/Table/renderMethods";
import { humanReadableDate } from "../../utils/date";
import Table from "../../designComponents/Table";
import { useNavigate } from "react-router-dom";
import { ButtonTab } from "../../designComponents/ButtonTab";
import Pagination from "../../components/Pagination";
type Props = {};
interface FilterValues {
  page: number;
  limit: number;
  filter: {
    mode: string;
  };
}
interface ReportBody {
  _id: string;
  publicContact?: {
    name?: string;
    email: string;
    phone?: string;
  };
  reportedByUser: {
    avatar: string;
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  reportedResourceId?: string;
  reportedResourceModel?: "User" | "Property" | "Booking" | "ManualContract";
  priority?: "HIGH" | "MEDIUM" | "LOW";
  description?: string;
  files?: Array<{
    url: string;
    size: number;
    sizeType: "mb" | "kb";
  }>;
  reportedTo?: string; // user id of resource owner (optional)
  isReportToAdmin?: boolean; // if reporting to Rentisity admins (optional)
  createdAt?: string;
  status: string;
}

const Reports = (props: Props) => {
  const [cardKey, setCardKey] = useState<string>("all");
  const navigate = useNavigate();
  const [reportDatas, setReports] = useState<ReportBody[]>([]);
  const [loading, setLoading] = useState(true);
  const handleCurrentPage = (page: number) => {
    setPaginationParams((prevParams) => ({ ...prevParams, page }));
  };

  const handleLimitChange = (limit: number) => {
    setPaginationParams((prevParams) => ({ ...prevParams, limit, page: 1 }));
  };
  const [paginationParams, setPaginationParams] = useState<FilterValues>({
    page: 1,
    limit: 10,
    filter: { mode: "all" },
  });
  const [pagination, setPagination] = useState({
    totalPages: 1,
    total: 0,
    currentPage: 1,
  });
  const getReportsApi = async (paginationParams: FilterValues) => {
    setLoading(true);

    try {
      const response = await requestAPI(reports.getReports(paginationParams));
      setReports(response.data);
      setPagination({
        totalPages: response?.pagination?.totalPages,
        total: response?.pagination?.total,
        currentPage: response?.pagination?.currentPage,
      });
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  const tableData = {
    headings: [
      { key: "sn", label: "SN." },
      { key: "reportedBy", label: "Reported By" },
      { key: "resourceModel", label: "Report On" },
      { key: "priority", label: "Priority" },
      { key: "date", label: "Date Reported" },
      { key: "status", label: "Status" },
    ],
    body: Array.isArray(reportDatas)
      ? reportDatas?.map((report, index) => ({
          id: report?._id,
          sn: `${index + 1}.`,
          reportedBy: renderFullDetails({
            avatar: report.reportedByUser.avatar,
            firstName: report.reportedByUser.firstName,
            lastName: report.reportedByUser.lastName,
            email: report.reportedByUser.email,
          }),
          resourceModel: report.reportedResourceModel,
          priority: report.priority,
          date: humanReadableDate(report.createdAt),
          status: renderstatus(report.status),
        }))
      : [],
  };
  useEffect(() => {
    getReportsApi(paginationParams);
  }, [paginationParams]);
  const cardData = [
    { title: "All", key: "all" },
    { title: "ReportedByMe", key: "reportedByMe" },
  ];
  const handleClick = (key: string) => {
    setCardKey(key);
    setPaginationParams((prev) => ({
      ...prev,
      page: 1,
      filter: { mode: key },
    }));
  };

  return (
    <Wrapper>
      <TitleSection>
        <Title>Reports Management</Title>
      </TitleSection>
      {/* <div style={{ width: 300 }}>
        <ButtonTab
          items={cardData}
          activeIndex={cardData.findIndex((x) => x.key === cardKey)}
          setActiveIndex={(index) => handleClick(cardData[index].key)}
        />
      </div> */}
      <Table
        rowClick={(id) => {
          navigate(`${id}`);
        }}
        tableData={tableData}
        isLoading={loading}
        noData="No data to display."
        showMenuIcon={false}
        evenRowBgColor="#fff"
        headingBgColor="#fdfdf9"
      />
      <Pagination
        activePage={pagination.currentPage}
        totalPages={pagination.totalPages}
        limit={paginationParams.limit}
        onCurrentPageChange={handleCurrentPage}
        onLimitChange={handleLimitChange}
      />
    </Wrapper>
  );
};

export default Reports;
